import { render, staticRenderFns } from "./BrancheModal.vue?vue&type=template&id=3f5be7b4"
import script from "./BrancheModal.vue?vue&type=script&lang=js"
export * from "./BrancheModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports